





























import Vue from 'vue'
import { getProducts } from '@/api/Topup/topup.api'
import TopUpPriceSettings from '@/components/Services/TopUps/TopUpPriceSettings.vue'
import ExitDialogVue from '@/components/Services/TopUps/ExitDialog.vue'
import { TranslateResult } from 'vue-i18n'
import { GetProductDTO } from '@/utils/interfaces/topup.interface'

export default Vue.extend({
  components: {
    appExitDialog: ExitDialogVue,
    appPriceSettings: TopUpPriceSettings,
  },
  data() {
    return {
      tab: 0,
      tabs: [] as GetProductDTO[],
      exitDialog: false,
    }
  },
  computed: {
    exitText(): TranslateResult {
      if (this.$store.getters.profile.role === 'ADMIN') {
        return this.$t('topup.admin-exit-dialog-text')
      } else return this.$t('topup.exit-dialog-text')
    },
    exitTo(): { name: string } {
      if (this.$store.getters.profile.role === 'ADMIN') {
        return { name: 'topup.provider-prices' }
      } else return { name: 'topup.list' }
    },
  },
  async mounted() {
    const response = await getProducts({ limit: 100 })
    if (!response.data.results.length) this.exitDialog = true
    else this.tabs = response.data.results
  },
})
